export default __webpack_public_path__ + "static/media/1952.391936b6.png";